<p-panel header="Chemical Dosage" styleClass="mb-3">
  @if (viewModel$ | async; as vm) {
    @if (loading()) {
      <div class="chemical-dosage-loading">
        <p-progressSpinner></p-progressSpinner>
      </div>
    }

    @if (!loading() && errorMessage()) {
      <p-message
        severity="error"
        styleClass="w-full">
        {{ errorMessage()! }}
      </p-message>
    }

    @if (!loading() && !errorMessage() && vm.hasData) {
      <div class="chemical-dosage-chart">
        <div class="chemical-dosage-chart-toolbar">
          <p-button icon="pi pi-refresh" size="small" severity="secondary" [rounded]="true" [text]="true" ariaLabel="Reset zoom" (onClick)="resetZoom()"></p-button>
        </div>
        <p-chart type="line" [data]="vm.data" [options]="vm.options"></p-chart>
      </div>
    }

    @if (!loading() && !errorMessage() && !vm.hasData) {
      <div class="chemical-dosage-empty text-color-secondary">
        {{ vm.emptyMessage }}
      </div>
    }
  }
</p-panel>
